import { Link, useNavigate } from 'react-router-dom';
import { BandeauAlerte, BandeauSignature, Embleme } from '../../components/index.js';
import { useChargement } from '../../hooks/useChargement.js';
import { useOrganisateur } from '../../hooks/useOrganisateur.js';
import { api, capitale, dateLongue, type Evenement } from '../../lib/api.js';

/** Liste des événements de l'organisateur. */
export function Evenements() {
  const organisateur = useOrganisateur();
  const navigate = useNavigate();
  const { donnees, erreur, enCours } = useChargement(() => api.get<{ events: Evenement[] }>('/api/events'), [organisateur?.id]);

  const deconnexion = async () => {
    await api.post('/api/auth/logout', {});
    navigate('/connexion');
  };

  return (
    <div className="page-liste">
      <header className="entete-liste">
        <div className="logo nameplate">
          <Embleme />
          <span className="pile" style={{ gap: 4 }}>
            <BandeauSignature petit />
            <span className="display" style={{ fontSize: 22 }}>
              Dîner tournant
            </span>
          </span>
        </div>
        {organisateur ? (
          <div className="ligne texte-muet" style={{ fontSize: 14 }}>
            {organisateur.email}
            <button type="button" className="btn" onClick={deconnexion}>
              Se déconnecter
            </button>
          </div>
        ) : null}
      </header>
      <main className="contenu-liste">
        <div className="entete-page">
          <h1 className="display">Mes événements</h1>
          <Link to="/app/evenements/nouveau" className="btn principal">
            + Nouvel événement
          </Link>
        </div>
        {erreur ? <BandeauAlerte niveau="attention" role="alert" titre={erreur} /> : null}
        {enCours && !donnees ? <p className="texte-muet">Chargement…</p> : null}
        {donnees && donnees.events.length === 0 ? (
          <div className="carte pile" style={{ maxWidth: 560 }}>
            <h2 style={{ fontSize: 18 }}>Aucun événement pour l'instant</h2>
            <p className="texte-doux">Créez votre premier dîner tournant : date, horaires des trois étapes, date limite d'inscription. Vous obtiendrez ensuite un lien d'inscription à partager.</p>
            <Link to="/app/evenements/nouveau" className="btn principal" style={{ alignSelf: 'flex-start' }}>
              Créer un événement
            </Link>
          </div>
        ) : null}
        {donnees && donnees.events.length > 0 ? (
          <ul className="liste-evenements">
            {donnees.events.map((e) => (
              <li key={e.id}>
                <Link to={`/app/e/${e.id}/evenement`} className="carte carte-evenement">
                  <span className="surtitre">{e.organisation ?? 'Événement'}</span>
                  <span className="nom">{e.nom}</span>
                  <span className="texte-doux">{capitale(dateLongue(e.date))}</span>
                  <span className="texte-muet" style={{ fontSize: 13 }}>
                    {e.repartitionGenereeAt ? 'Répartition générée' : 'Inscriptions en cours'}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        ) : null}
      </main>
    </div>
  );
}
